import { ChangeEvent } from 'react';
import { RANGE_INPUT_OMITTED_CHARACTERS } from '@sib/config';
import { Input, cn } from '@sib/ui';

interface RangeInputFieldProps {
  label: string;
  value: number | '';
  min: number;
  max: number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  fullWidth?: boolean;
}

export const RangeInputField = ({
  label,
  value,
  min,
  max,
  onChange,
  fullWidth = false,
}: RangeInputFieldProps) => (
  <div className={cn('flex flex-col gap-1', fullWidth ? 'w-full' : 'w-24')}>
    <span className="text-primary text-xs font-medium">{label}</span>
    <Input
      type="number"
      hideNumberSpinButtons
      min={min}
      max={max}
      value={value}
      onChange={onChange}
      className="h-9"
      omitCharacters={RANGE_INPUT_OMITTED_CHARACTERS}
    />
  </div>
);
